import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  // This site has no signed-in surface: no server function uses
  // `requireSupabaseAuth`, so the generated `attachSupabaseAuth` middleware is
  // intentionally NOT registered. Registering it statically pulls all of
  // @supabase/supabase-js (auth-js, realtime/phoenix, storage-js) into the main
  // client bundle as unused JavaScript. Re-add it if auth is introduced.
  requestMiddleware: [errorMiddleware],
}));
